import type { NavigationState, PartialState } from '@react-navigation/native';

// Campaign parameters stay outside navigation state to avoid URL encoding
// differences when React Navigation verifies a route's original path.
export function createLandingUtmTracker() {
  let utmParams: Record<string, string> | undefined;
  let landingPath: string | undefined;
  let captured = false;
  let pageViewPending = true;

  return {
    capture(params: Record<string, string>) {
      if (captured || Object.keys(params).length === 0) return;
      captured = true;
      utmParams = params;
    },
    getPath(path: string) {
      // Always return an origin-relative path, including the serializer fallback.
      const normalizedPath = `/${path.replace(/^\/+/, '')}`;
      const url = new URL(normalizedPath, 'https://partage.club');
      if (!utmParams || (landingPath && url.pathname !== landingPath)) return normalizedPath;

      for (const [key, value] of Object.entries(utmParams)) url.searchParams.set(key, value);
      return url.pathname + url.search + url.hash;
    },
    takePageViewParams(path: string) {
      const { pathname } = new URL(path, 'https://partage.club');
      landingPath ??= pathname;
      if (pathname !== landingPath) utmParams = undefined;
      if (!pageViewPending) return undefined;
      pageViewPending = false;
      return utmParams;
    },
  };
}
export function removeFocusedRoutePath(state: PartialState<NavigationState>) {
  let focusedState = state;
  while (focusedState.routes.length > 0) {
    const index = focusedState.index ?? focusedState.routes.length - 1;
    const route = focusedState.routes[index];
    if (!route) return;
    if (!route.state) {
      focusedState.routes[index] = { ...route, path: undefined };
      return;
    }
    focusedState = route.state;
  }
}
